<template>
  <!-- 住院费用清单 -->
  <div class="hospitalizationExpensesList">
    <van-cell is-link @click="showPopup" arrow-direction="down">
      {{ chooseDateTime }}
    </van-cell>
    <div class="amount">
      <div>本日花费金额(元)</div>
      <div class="number">{{ formattedCost(allExpense) }}</div>
    </div>

    <div class="expensesList">
      <div class="title">
        <span>项目名称</span>
        <span>单价(元)</span>
        <span>数量</span>
        <span>金额(元)</span>
      </div>
      <div class="allList">
        <div v-for="(item, index) in expensesList" :key="index" class="oneList">
          <span>{{ item.itemName }}</span>
          <span>{{ formattedCost(item.unitPrice) }}</span>
          <span>{{ item.quantity }}</span>
          <span>{{ formattedCost(item.cost) }}</span>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :close-on-click-overlay="true" @click-overlay="confirm">
      <van-datetime-picker v-model="currentDate" type="date" title="" :formatter="formatter" :min-date="minDate" :max-date="maxDate">
        <!-- 取消顶部默认的文字 -->
        <template #default>
          <div></div>
        </template>
        <template #columns-bottom>
          <div class="columns-bottom">
            <van-button round plain @click="cancel">取消</van-button>
            <van-button round type="primary" @click="confirm">确定</van-button>
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import { inpatientBills } from '@/api/datasyncDataviewsimulator/yinyitong/inpatient';

export default {
  data() {
    return {
      show: false,
      currentDate: new Date(),
      minDate: new Date(2024, 0, 1),
      maxDate: new Date(2024, 11, 1),
      expensesList: [],
      allExpense: '0'
    };
  },
  computed: {
    chooseDateTime() {
      const date = this.currentDate;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1并补零
      const day = String(date.getDate()).padStart(2, '0'); // 日也补零
      return `${year}-${month}-${day}`;
    }
  },
  mounted() {
    this.confirm();
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    formatter(type, val) {
      if (type == 'year') {
        return `${val}年`;
      } else if (type == 'month') {
        return `${val}月`;
      } else if (type == 'day') {
        return `${val}日`;
      }
      console.log('val', val);
      return val;
    },
    cancel() {
      this.currentDate = new Date();
      this.show = false;
    },
    async confirm() {
      this.show = false;
      try {
        const data = {
          InpatientCode: '8001126876',
          beginDate: new Date(this.currentDate).getTime(),
          endDate: new Date(this.currentDate).getTime()
        };
        const res = await inpatientBills(data);
        if (!!res && res.data) {
          this.expensesList = res.data.hospitalizationCostInformations;
          this.allExpense = this.expensesList.reduce((total, item) => {
            return total + (item.cost || 0); // 确保cost存在，否则使用0
          }, 0); // 初始值为0
        }
      } catch (err) {
        console.log('err', err);
      }
    },
    //保留两位小数位
    formattedCost(val) {
      if (!!val) {
        return parseFloat(val).toFixed(2);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hospitalizationExpensesList {
  ::v-deep .van-cell {
    margin: 0 auto;
    font-size: 4.8vw;
    justify-content: center;
    &::after {
      border: none;
    }
    .van-cell__title,
    .van-cell__value {
      flex: none;
    }
    .van-cell__right-icon {
      color: #01cc88;
    }
  }
  ::v-deep .van-picker__toolbar {
    height: 0;
  }
  ::v-deep .van-picker__columns {
    height: 40vh !important;
  }
  .columns-bottom {
    height: 12vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-button {
      width: 40vw;
      background: #fff;
      color: #000;
      font-size: 5.9vw;
      border: 1px solid #999 !important;
      border-radius: 2.1vw;
      margin: 0 1.5vw;
      &:last-child {
        color: #fff;
        background: #01cc88;
        border: 1px solid #01cc88 !important;
      }
    }
  }
  .amount {
    color: #666666;
    font-size: 4.3vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    .number {
      font-size: 6.9vw;
      color: #ca3e3d;
    }
  }
  .expensesList {
    margin-top: 3.5vh;
    .title {
      border-top: 2px solid #01cc88;
      border-bottom: 1px solid #cccccc;
      padding: 1.2vh 0;
      box-sizing: border-box;
      span {
        display: inline-block;
        color: #666;
        font-size: 3.7vw;
        text-align: center;
        &:nth-child(1) {
          width: 38.5vw;
          padding-left: 2vw;
          box-sizing: border-box;
          text-align: left;
        }
        &:nth-child(2) {
          width: 24.5vw;
        }
        &:nth-child(3) {
          width: 17.5vw;
        }
        &:nth-child(4) {
          width: 18vw;
        }
      }
    }
    .allList {
      height: 75vh;
      overflow-y: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, and Opera */
      }
      .oneList {
        border-bottom: 1px solid #cccccc;
        padding: 1.7vh 0;
        box-sizing: border-box;
        span {
          display: inline-block;
          color: #000;
          font-size: 3.7vw;
          text-align: center;
          &:nth-child(1) {
            width: 38.5vw;
            padding-left: 2vw;
            box-sizing: border-box;
            text-align: left;
          }
          &:nth-child(2) {
            width: 24.5vw;
          }
          &:nth-child(3) {
            width: 17.5vw;
          }
          &:nth-child(4) {
            width: 18vw;
          }
        }
      }
    }
  }
}
</style>
